import React from "react";

function SkeletonRow() {
  return (
    <tr className="border-b border-slate-100 dark:border-white/5">
      <td className="px-5 py-4">
        <div className="h-9 w-28 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
      </td>

      <td className="px-5 py-4">
        <div className="h-5 w-56 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        <div className="mt-2 h-4 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      </td>

      <td className="px-5 py-4">
        <div className="h-9 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      </td>

      <td className="px-5 py-4">
        <div className="flex gap-2">
          <div className="h-8 w-8 animate-pulse rounded-xl bg-slate-200 dark:bg-white/10" />
          <div className="h-8 w-8 animate-pulse rounded-xl bg-slate-200 dark:bg-white/10" />
          <div className="h-8 w-8 animate-pulse rounded-xl bg-slate-200 dark:bg-white/10" />
        </div>
      </td>

      <td className="px-5 py-4">
        <div className="h-4 w-64 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        <div className="mt-2 h-4 w-40 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      </td>

      <td className="px-5 py-4">
        <div className="h-10 w-32 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
      </td>

      <td className="px-5 py-4">
        <div className="ml-auto h-10 w-40 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
      </td>
    </tr>
  );
}

function PalmaresSkeleton() {
  return (
    <div className="mt-6 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="border-b border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/[0.03]">
        <div className="h-4 w-36 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        <div className="mt-3 h-8 w-64 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-[1050px] w-full border-collapse">
          <thead>
            <tr className="border-b border-slate-200 dark:border-white/10">
              <th className="px-5 py-4">
                <div className="h-3 w-16 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
              <th className="px-5 py-4">
                <div className="h-3 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
              <th className="px-5 py-4">
                <div className="h-3 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
              <th className="px-5 py-4">
                <div className="h-3 w-20 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
              <th className="px-5 py-4">
                <div className="h-3 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
              <th className="px-5 py-4">
                <div className="h-3 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
              <th className="px-5 py-4">
                <div className="ml-auto h-3 w-20 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              </th>
            </tr>
          </thead>

          <tbody>
            <SkeletonRow />
            <SkeletonRow />
            <SkeletonRow />
            <SkeletonRow />
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PalmaresSkeleton;